import SalonBusinessCpaTopicWorkspace from "./SalonBusinessCpaTopicWorkspace";

export default function SalonBusinessCpaFinancialStatements() {
  return <SalonBusinessCpaTopicWorkspace topicKey="financial_statements" />;
}
